// AIT-355 — shared branded 404 body. Used by the splat route's component
// (unknown paths) and the root ErrorBoundary (404 route errors from
// anywhere else). Unknown paths keep their 404 STATUS — no soft-404
// redirect-to-home (hides broken links, gets reclassified by crawlers).
export function NotFound() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <img src="/logo-mark.svg" alt="HookMyApp" className="mb-8 h-12 w-12" />
      <h1 className="text-4xl font-medium tracking-tight text-white">Page not found</h1>
      <p className="mt-4 max-w-md text-lg text-white/65">
        The page you&rsquo;re looking for doesn&rsquo;t exist or has moved.
      </p>
      <div className="mt-10 flex items-center gap-4">
        <a
          href="/"
          className="inline-flex items-center justify-center rounded-[100px] bg-[#0064E0] px-8 py-4 text-base font-medium text-white transition hover:bg-[#0143B5]"
        >
          Back to home
        </a>
        <a
          href="https://docs.hookmyapp.com"
          className="text-base text-white/65 underline-offset-4 hover:text-white hover:underline"
        >
          Docs
        </a>
      </div>
    </main>
  );
}
